module.exports = __webpack_public_path__ + "img/inu_gallery1.06ba682e.jpg";